export enum Handelsstand {
  HGB84 = "§ 84 HGB",
  HGB93 = "§ 93 HGB"
}
